import styled from 'styled-components';
import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { ColorVarsEnum } from 'enums/ColorVarsEnum';
import React from 'react';
import { TOOLTIP } from 'modules/workspace/constans';

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    arrow
    disableInteractive={props.disableInteractive ?? true}
    placement={props.placement || 'top'}
    translate="yes"
    enterNextDelay={props.enterNextDelay || 1000}
    slotProps={{
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -7],
            },
          },
        ],
      },
    }}
    {...props}
    classes={{ popper: `${className}  ${TOOLTIP}` }}
  >
    <div>{props.children}</div>
  </Tooltip>
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `var(${ColorVarsEnum.Sub_Level_bg_1})`,
    borderRadius: '4px',
    padding: '4px 8px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.15)',
    color: `var(${ColorVarsEnum.Sub_Level_1})`,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    margin: 0,
    whiteSpace: 'pre-wrap',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: `var(${ColorVarsEnum.Sub_Level_bg_1})`,
  },
}));
